module.exports = __webpack_public_path__ + "static/media/arrow-up-right-blue.e8a5a0e3.svg";